module.exports = __webpack_public_path__ + "static/media/background.d5402f02.jpg";